/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_scatter_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scatter Plot Maker`)
};

const es_scatter_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creador de Diagramas de Dispersión`)
};

const de_scatter_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Streudiagramm-Ersteller`)
};

const nl_scatter_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spreidingsdiagrammaker`)
};

const fr_scatter_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créateur de nuage de points`)
};

const it_scatter_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creatore di grafici a dispersione`)
};

const pt_br2_scatter_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de Gráfico de Dispersão`)
};

const pt_scatter_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criador de Gráficos de Dispersão`)
};

const ja_scatter_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`散布図作成ツール`)
};

const zh_scatter_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`散点图制作工具`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const scatter_tool_name = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.scatter_tool_name(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("scatter_tool_name", locale)
	if (locale === "en") return en_scatter_tool_name(inputs)
	if (locale === "es") return es_scatter_tool_name(inputs)
	if (locale === "de") return de_scatter_tool_name(inputs)
	if (locale === "nl") return nl_scatter_tool_name(inputs)
	if (locale === "fr") return fr_scatter_tool_name(inputs)
	if (locale === "it") return it_scatter_tool_name(inputs)
	if (locale === "pt-BR") return pt_br2_scatter_tool_name(inputs)
	if (locale === "pt") return pt_scatter_tool_name(inputs)
	if (locale === "ja") return ja_scatter_tool_name(inputs)
	return zh_scatter_tool_name(inputs)
};